<template>
  <div class="agent-session">
    <sub-title title="跟进复盘"></sub-title>
    <AgentDesc :avatar-index="10" name="跟进助手"></AgentDesc>
    <div class="agent-session-body">
      <div
        v-for="item in cardList"
        :key="item.id"
        class="session-card"
        :class="{
          'info-card': item.type === 1,
          'err-card': item.type === 3,
          'success-card': item.type === 2
        }"
        @click="handleClickCard(item)"
      >
        <i
          class="prefix-icon t-iconfont"
          :class="{
            'icon-checkbox-circle-line': item.type === 2,
            'icon-information-line': [1, 3].includes(item.type)
          }"
        ></i>
        <div class="session-card__main">
          <div class="title">{{ item.title }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
        <i class="icon-arrow-right-line subfix-icon t-iconfont"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import subTitle from './components/sub-title.vue'
import AgentDesc from './components/agent-desc.vue'
import { computed } from 'vue'
import xbb from '@xbb/xbb-utils'

const props = defineProps({
  followList: {
    type: Array,
    default: () => []
  }
})

const emits = defineEmits(['openSession', 'openDetail', 'handleSelect', 'handleRead'])

const cardList = computed(() => {
  return props.followList.map((item) => {
    const getTitle = (type) => {
      switch (type) {
        case 1:
          return `你有 ${item.num} 条录音尚未绑定`
        case 2:
          return `你有一条跟进已完成分析`
        case 3:
          return `你有一条跟进入库失败`
        default:
          return ''
      }
    }
    const getDesc = (type) => {
      switch (type) {
        case 1:
          return '点击前往绑定'
        case 2:
          return `${item.name}（${xbb.formatTime(item.time, 'yyyy-MM-dd HH:mm')}）`
        case 3:
          return `${item.name}（${xbb.formatTime(item.time, 'yyyy-MM-dd HH:mm')}）`
        default:
          return ''
      }
    }
    return {
      ...item,
      type: item.type,
      title: getTitle(item.type),
      desc: getDesc(item.type)
    }
  })
})

const handleClickCard = (item) => {
  if (item.type === 1) {
    emits('handleSelect', item)
  } else if (item.type === 3) {
    emits('openSession', item)
    emits('handleRead', { id: item.id, refType: 4 })
  } else if (item.type === 2) {
    emits('openDetail', item)
    emits('handleRead', { id: item.id, refType: 4 })
  }
}
</script>

<style lang="scss" scoped>
.agent-session {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 16px;
  &-body {
    flex: 1;
    padding-left: 32px;
    display: flex;
    flex-direction: column;
    position: relative;
    .session-card {
      border-radius: 16px;
      background: #ffffff;
      padding: 12px;
      box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.05);
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .prefix-icon {
        flex: 0 0 auto;
        font-size: 18px;
        margin-right: 12px;
      }
      .subfix-icon {
        flex: 0 0 auto;
        font-size: 18px;
        margin-left: 12px;
        color: #969799;
        cursor: pointer;
      }
      .session-card__main {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .title {
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          color: #323233;
          margin-bottom: 4px;
        }
        .desc {
          font-size: 12px;
          line-height: 16px;
          color: #646566;
        }
      }
    }
    .info-card {
      border: 1px solid #e8f7ff;
      .prefix-icon {
        color: #248df5;
      }
    }
    .err-card {
      border: 1px solid #ffece8;
      .prefix-icon {
        color: #f54e4e;
      }
    }
    .success-card {
      border: 1px solid #e8ffec;
      .prefix-icon {
        color: #00c241;
      }
    }
  }
}
</style>
